export const navLinks = [
  {
    label: 'Projects',
    pathname: '/#project-1',
    hotkey: '2',
  },
  {
    label: 'About',
    pathname: '/#details',
    hotkey: '3',
  },
  {
    label: 'Blog',
    pathname: '/articles',
    hotkey: '4',
  },
  {
    label: 'Stack',
    pathname: '/stack',
    hotkey: '5',
  },
  {
    label: 'Bookshelf',
    pathname: '/bookshelf/',
    hotkey: '6',
  },
  /* Last: it is the end of the pitch, not a stop along the way. */
  {
    label: 'Contact',
    pathname: '/contact',
    hotkey: '7',
  },
];

export const socialLinks = [
  {
    label: 'X',
    url: 'https://x.com/TimothyDiarmada',
    icon: 'x',
  },
  {
    label: 'linkedin',
    url: 'https://www.linkedin.com/in/timothymcd/',
    icon: 'linkedin',
  },
  {
    label: 'Github',
    url: 'https://github.com/txmxthy',
    icon: 'github',
  },
];
